import { render, staticRenderFns } from "./telegramList.vue?vue&type=template&id=00c24397&scoped=true"
import script from "./telegramList.vue?vue&type=script&lang=js"
export * from "./telegramList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c24397",
  null
  
)

export default component.exports